import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'System';

const syncHistory = [
  {
    matchRegex: '/AccountIntegration/SyncHistory',
    name: getRouteName(MODULE_NAME, 'Sync History'),
    slots: [
      SLOT_KEY.SLOT_ADDITION_MENU,
    ]
  },
];

export default syncHistory;
